"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var storage_1 = require("./storage");

var util_1 = require("./util");

exports.DEFAULT_LEEWAY = 1200;
exports.responseType = 'token id_token';

var Authenticator =
/** @class */
function () {
  function Authenticator(client, logoutRedirectUrl, options) {
    if (options === void 0) {
      options = {};
    }

    this.client = client;
    this.logoutRedirectUrl = logoutRedirectUrl;
    this.options = options;
    this.authStorage = storage_1.makeAuthStorage({
      storage: options.storage,
      keys: options.storageKeys
    });
  }

  Authenticator.prototype.getUserId = function () {
    return this.authStorage.retrieveUserId();
  };

  Authenticator.prototype.getAccessToken = function () {
    return this.authStorage.retrieveAccessToken();
  };

  Authenticator.prototype.getAuthStorage = function () {
    return this.authStorage;
  };

  Authenticator.prototype.promptLogin = function (currentLocation, opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.authStorage.storeLoginLocation(currentLocation);
    this.client.authorize(__assign({}, opts, {
      responseType: exports.responseType
    }));
  };

  Authenticator.prototype.handleLoginSuccess = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.client.parseHash(function (error, parsed) {
        if (parsed) {
          try {
            var _a = extractAuthData(parsed),
                accessToken = _a.accessToken,
                userId = _a.userId,
                expiresAt = _a.expiresAt;

            var redirectTo = _this.authStorage.retrieveLoginLocation();

            _this.authStorage.removeLoginLocation();

            _this.authStorage.storeUserId(userId);

            _this.authStorage.storeAccessToken(accessToken);

            _this.authStorage.storeExpiresAt(expiresAt);

            _this.setReauthenticationTimeout(expiresAt);

            resolve({
              accessToken: accessToken,
              userId: userId,
              expiresAt: expiresAt,
              redirectTo: redirectTo
            });
          } catch (error) {
            reject(error);
          }
        } else if (error) {
          reject(error);
        } else {
          reject(new Error('parseHash neither parsed the hash successfully nor returned an error'));
        }
      });
    });
  };

  Authenticator.prototype.authenticate = function (currentLocation) {
    var _this = this;

    var authStorage = this.authStorage;
    var client = this.client;
    var state = util_1.randomString();
    return new Promise(function (resolve) {
      var accessToken = authStorage.retrieveAccessToken();

      if (!accessToken) {
        if (currentLocation) {
          authStorage.storeLoginLocation(currentLocation);
          client.authorize({
            responseType: exports.responseType,
            state: state
          });
        }

        resolve({});
      }

      var expiresAt = authStorage.retrieveExpiresAt();

      var _a = extractExpirationData(expiresAt, _this.getReauthenticationLeeway()),
          isFresh = _a[0],
          isExpiringSoon = _a[1];

      if (!isFresh && currentLocation) {
        authStorage.storeLoginLocation(currentLocation);
        authStorage.removeAccessToken();
        authStorage.removeExpiresAt();
        client.authorize({
          responseType: exports.responseType,
          state: state
        });
        resolve({});
      }

      if (isFresh && isExpiringSoon) {
        return _this.reauthenticate().then(function (_a) {
          var userId = _a.userId,
              accessToken = _a.accessToken,
              expiresAt = _a.expiresAt;

          if (accessToken && expiresAt) {
            authStorage.storeAccessToken(accessToken);
            authStorage.storeExpiresAt(expiresAt);

            _this.setReauthenticationTimeout(expiresAt);

            _this.handleReauthenticationSuccess({
              userId: userId,
              accessToken: accessToken,
              expiresAt: expiresAt
            });

            resolve({
              accessToken: accessToken,
              expiresAt: expiresAt
            });
          }
        }).catch(function (error) {
          authStorage.removeUserId();
          authStorage.removeAccessToken();
          authStorage.removeExpiresAt();

          _this.handleReauthenticationFailure(error);

          resolve({});
        });
      }

      _this.setReauthenticationTimeout(expiresAt);

      resolve({
        userId: authStorage.retrieveUserId(),
        accessToken: accessToken,
        expiresAt: expiresAt
      });
    });
  };

  Authenticator.prototype.logout = function () {
    this.authStorage.removeUserId();
    this.authStorage.removeAccessToken();
    this.authStorage.removeExpiresAt();
    this.client.logout({
      returnTo: this.logoutRedirectUrl
    });
  };

  Authenticator.prototype.getReauthenticationLeeway = function () {
    var seconds = this.options.reauthenticationLeeway || exports.DEFAULT_LEEWAY;
    return seconds * 1000;
  };

  Authenticator.prototype.setReauthenticationTimeout = function (expiresAt) {
    window.clearTimeout(this.reauthTimeoutId);
    var timeout = expiresAt - this.getReauthenticationLeeway() - Date.now();
    this.reauthTimeoutId = window.setTimeout(this.authenticate.bind(this), timeout);
  };

  Authenticator.prototype.handleReauthenticationSuccess = function (result) {
    var handleSuccess = this.options.onReauthenticationSuccess || util_1.noop;
    handleSuccess(result);
  };

  Authenticator.prototype.handleReauthenticationFailure = function (error) {
    var handleFailure = this.options.onReauthenticationFailure || util_1.noop;
    handleFailure(error);
  };

  Authenticator.prototype.reauthenticate = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var opts = {
        responseType: exports.responseType
      };

      _this.client.checkSession(opts, function (error, result) {
        if (error) {
          reject(error);
        }

        try {
          var _a = extractAuthData(result),
              userId = _a.userId,
              accessToken = _a.accessToken,
              expiresAt = _a.expiresAt;

          resolve({
            userId: userId,
            accessToken: accessToken,
            expiresAt: expiresAt
          });
        } catch (error) {
          _this.handleReauthenticationFailure(error);
        }
      });
    });
  };

  return Authenticator;
}();

exports.Authenticator = Authenticator;

function extractAuthData(parsed) {
  var idTokenPayload = parsed.idTokenPayload,
      accessToken = parsed.accessToken,
      expiresIn = parsed.expiresIn;

  if (typeof idTokenPayload !== 'object') {
    throw new Error("expected idTokenPayload to be an object, got " + idTokenPayload);
  }

  if (typeof accessToken !== 'string') {
    throw new Error("expected accessToken to be a string, got " + accessToken);
  }

  if (!expiresIn || typeof expiresIn !== 'number' || !(expiresIn > -1)) {
    throw new Error("expected expiresIn to be a positive integer, got " + expiresIn);
  }

  var sub = idTokenPayload.sub;

  if (!sub) {
    throw new Error('idTokenPayload.sub not found in parsed hash');
  }

  var expiresAt = Date.now() + expiresIn * 1000;
  return {
    userId: sub,
    accessToken: accessToken,
    expiresAt: expiresAt
  };
}

exports.extractAuthData = extractAuthData;

function extractExpirationData(expiresAt, leeway) {
  if (!expiresAt) {
    return [false];
  }

  var expiresWithin = expiresAt - Date.now();

  if (isNaN(expiresWithin) || expiresWithin < 0) {
    return [false];
  }

  var isExpiringSoon = leeway && Number.isInteger(leeway) ? expiresWithin < leeway : true;
  return [true, isExpiringSoon];
}

exports.extractExpirationData = extractExpirationData;